module.exports = [{
      plugin: require('/Users/konstantin/work/src/monsterparkbox.com/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
